import { NumberFormatter, NumberInput } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { FictionalEnergyValueResponse } from "../../FictionalEnergyValueManager/FictionalEnergyValueManager";
import { updateRowData } from "./updateRowData";

function getTechnischeNichtverfuegbarkeitColumn(
  creationError: string | null,
  editingError: string | null
): MRT_ColumnDef<FictionalEnergyValueResponse> {
  return {
    accessorKey: "technischeNichtverfuegbarkeitKwh",
    header: "Technische Nichtverfügbarkeit (kWh)",
    Cell: ({ cell }) => <NumberFormatter value={Number(cell.getValue())} />,
    Edit: ({ table, row, cell }) => {
      return (
        <NumberInput
          defaultValue={Number(cell.getValue())}
          error={
            table.getState().creatingRow?.id === row.id
              ? creationError
              : editingError
          }
          placeholder="Technische Nichtverfügbarkeit (kWh)"
          onChange={(value) =>
            updateRowData({
              table,
              row,
              columnIds: ["technischeNichtverfuegbarkeitKwh"],
              newValues: [value]
            })
          }
        />
      );
    }
  };
}

export { getTechnischeNichtverfuegbarkeitColumn };
